import { AcceptSuccessTrackers } from '@olxeu-a2b/ui/typings/safeDealTracking';
import trackingKeys from '../../tracking/trackingKeys';
import useSafeDealEventTracking from './useSafeDealEventTracking';
import useSafeDealLinkEventTracking from './useSafeDealLinkEventTracking';

const { deliverySafeDealAcceptSuccessShow, deliverySafeDealAcceptGoToMydelivClick } =
  trackingKeys.events;

export const useSafeDealAcceptSuccessTracking = (adId: string): AcceptSuccessTrackers => {
  const trackAcceptSuccessShow = useSafeDealEventTracking(deliverySafeDealAcceptSuccessShow, adId);

  const trackAcceptGoToMydelivClick = useSafeDealLinkEventTracking(
    deliverySafeDealAcceptGoToMydelivClick,
    adId,
  );

  return {
    trackAcceptSuccessShow,
    trackAcceptGoToMydelivClick,
  };
};

export default useSafeDealAcceptSuccessTracking;
